// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1tS8g","title":"ClientReferral_title__1S1RL","itemText":"ClientReferral_itemText__-2ZfB"};